import { Link } from "react-router";

export function NotFoundPage() {
  return (
    <div className="auth">
      <div className="auth-card" style={{ textAlign: "center" }}>
        <h1 className="auth-title">走错门了</h1>
        <p className="auth-sub">这个地址不存在。</p>
        <Link to="/" className="btn btn-primary btn-block">
          回到首页
        </Link>
      </div>
    </div>
  );
}
